import ExamContext from 'presentation/contexts/exams/exam-context'

export default function makeExamStore() {
  return new ExamContext()
}
